// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminEvaluationListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(evaluationId) {
    this.props.history.push(`/admin/authoring/evaluations/${evaluationId}`);
  }

  render() {
    const { evaluation, contentModuleList } = this.props;
    const selectedContentModule = contentModuleList.filter(contentModule => contentModule._id === evaluation._contentModule);
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, evaluation._id)}>
        <td className="_40">{evaluation.title}</td>
        <td className="_20">{selectedContentModule.length > 0 ? selectedContentModule[0].title : ''}</td>
        <td className="_20">{evaluation.status}</td>
        <td className="_20">{moment(evaluation.updated).format("MMMM Do YYYY, h:mm a")}</td>
      </tr>
    )
  }
}

AdminEvaluationListItem.propTypes = {
  evaluation: PropTypes.object.isRequired
  , contentModuleList: PropTypes.array.isRequired
}

export default withRouter(AdminEvaluationListItem);



// WEBPACK FOOTER //
// modules/evaluation/components/AdminEvaluationListItem.js.jsx